module.exports = __webpack_public_path__ + "static/media/iconEdit.1edef87d.svg";